module.exports = [
	{
		"title": {
			"cs-CZ": "Musica pro Sancta Cecilia nabízí:",
			"en-GB": "Musica pro Sancta Cecilia offers:",
			"fr-FR": "Musica pro Sancta Cecilia offert:",
			"de-DE": "Musica pro Sancta Cecilia bietet:"
		},
		"text": {
			"cs-CZ": [
				"1. Kratší program vhodný ke zpestření konferencí, vernisáží apod. ",
				"2. Samostatné odpolední nebo večerní vystoupení v rozsahu přibližně 60 minut.",
				"3. Výchovné koncerty pro různé typy škol.",
				"4. Hudbu vhodnou k liturgii a k různým slavnostním obřadům."
			],
			"en-GB": [
				"1. Shorter program suitable to liven up a convention, opening, etc.",
				"2. Afternoon or evening performance of approximately 60 minutes duration.",
				"3. Educational concerts for schools.",
				"4. Music appropriate for liturgy and other ceremonies."
			],
			"fr-FR": [
				"1. Programme plus court adapté pour animer une convention, une ouverture, etc.",
				"2. Spectacle de l'après-midi ou du soir d'une durée d'environ 60 minutes.",
				"3. Concerts éducatifs pour les écoles.",
				"4. Musique appropriée pour la liturgie et autres cérémonies."
			],
			"de-DE": [
				"1. Ein Kurzprogramm, geeignet für die musikalische Untermahlung eines Kongresses oder einer Eröffnungsveranstaltung.",
				"2. Nachmittags- oder Abendkonzerte mit einer Länge von etwa 60 Minuten.",
				"3. Unterricht unterstützende Konzerte an Schulen.",
				"4. Passende Musik für Gottesdienste und andere Feierlichkeiten."
			]
		}
	},
	{
		"title": {
			"cs-CZ": "Cena za vystoupení:",
			"en-GB": "Prize for performance:",
			"fr-FR": "Prix de la performance :",
			"de-DE": "Preise:"
		},
		"text": {
			"cs-CZ": [
				"1. Cena především musí pokrýt provozní náklady spojené s vystoupením souboru (v Praze a v okolí 2000 - 8000 Kč)",
				"2. U mimopražských vystoupení upřednostňujeme termíny během víkendů.",
				"3. O podmínkách případné spolupráce se lze dohodnout na <a href='/Contacts'>kontaktních adresách</a>."
			],
			"en-GB": [
				"1. Price must cover the operating costs for performance (in Prague and in the region 2000 - 8000 Kč)",
				"2. Performances outside Prague are given preference during the weekend.",
				"3. Conditions about cooperation can be arranged. If interested, see contact list."
			],
			"fr-FR": [
				"1. Le prix doit couvrir les frais de fonctionnement pour la performance (à Prague et dans la région 2000 - 8000 Kč)",
				"2. Les représentations en dehors de Prague sont privilégiées pendant le week-end.",
				"3. Des conditions de coopération peuvent être fixées. Si vous êtes intéressé, consultez la liste des contacts."
			],
			"de-DE": [
				"1. Bitte haben Sie Verständnis, dass der Preis möglichst die Eigenkosten decken sollte (in Prag und Umgebung etwa 2000 – 8000 Kč)",
				"2. Konzerten außerhalb Prags wird am Wochenende der Vorzug gegeben",
				"3. Gerne treffen wir mit Ihnen auch Sondervereinbarungen. Bei Interesse, siehe Kontaktliste"
			]
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/components/Service/Service.json
// module id = 91
// module chunks = 0